import { TIER_MAKE_MODEL_PAGES, TIER_PAGES } from "../product/product-constants";

export function getTier0UrlAndPageType(tiersWithUrls) {
  const item = tiersWithUrls.find((tier) => [TIER_PAGES[0], TIER_MAKE_MODEL_PAGES[0]].includes(tier.pageType));
  if (item) {
    return { url: item.url, pageType: item.pageType };
  }
  return "";
}
